import { render, staticRenderFns } from "./SpendLimitReportPanel.vue?vue&type=template&id=18903c94&scoped=true"
import script from "./SpendLimitReportPanel.vue?vue&type=script&lang=js"
export * from "./SpendLimitReportPanel.vue?vue&type=script&lang=js"
import style0 from "./SpendLimitReportPanel.vue?vue&type=style&index=0&id=18903c94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18903c94",
  null
  
)

export default component.exports